<template>
    <section class="hero confirm-mail is-fullheight">
        <div class="hero-body">
            <div class="container">
                <!--suppress HtmlUnknownTarget -->
                <img
                    v-if="$saas.main"
                    alt="logo"
                    :src="require(`@/assets/${ $saas.logo }`)">
                <!--suppress HtmlUnknownTarget -->
                <img
                    alt="mail-image"
                    src="@/assets/MailConfirmation/confirmed.png">
                <h1 class="has-text-black is-title has-text-centered">
                    {{ $t(`common.mailConfirmation.confirmed.title`) }}
                </h1>
                <router-link
                    :to="{ name: 'main' }"
                    class="button is-success is-rounded is-fullwidth">
                    {{ $t(`common.mailConfirmation.confirmed.link`) }}
                </router-link>
            </div>
        </div>
    </section>
</template>

<script>
  export default {
    name: "MailConfirmationConfirmed"
  };
</script>
